import React from 'react'
import { Modal } from 'semantic-ui-react'
import { FlexRowBetween, TitleText } from 'components'
import { AppButton } from 'elements'
import { X } from 'phosphor-react'
import {
    formatRunWindow,
    formatUtcInTimezone,
    getLastRunBadge,
    getRunTrigger,
} from './consolidated-report-email-utils'
import { ErrorPre, ModalKv, StatusBadge } from './consolidated-report-email-styles'

const triggerLabel = trigger => {
    switch (trigger) {
        case 'Manual':
            return 'Manual (Fire Now)'
        case 'Test':
            return 'Test'
        default:
            return 'Scheduler (automatic)'
    }
}

export const ViewRunDetailModal = ({ open, onClose, run, timezone }) => {
    if (!run) return null

    const statusBadge = getLastRunBadge(run.Status)
    const trigger = getRunTrigger(run)
    const isFailed = run.Status === 'Failed' || run.Status === 'Failed-Skipped'
    const triggeredByName =
        run.TriggeredByName ||
        (run.TriggeredBy &&
        run.TriggeredBy !== 'Manual' &&
        run.TriggeredBy !== 'Test' &&
        run.TriggeredBy !== 'Scheduler'
            ? run.TriggeredBy
            : null)

    return (
        <Modal open={open} onClose={onClose} size="small">
            <Modal.Header>
                <FlexRowBetween>
                    <TitleText>Run detail — {run.ScheduleName}</TitleText>
                    <X
                        size={20}
                        style={{ cursor: 'pointer' }}
                        onClick={onClose}
                    />
                </FlexRowBetween>
            </Modal.Header>
            <Modal.Content>
                <ModalKv>
                    <span className="k">Fired at</span>
                    <span className="v">
                        {formatUtcInTimezone(run.FiredAtUtc, timezone, {
                            year: 'numeric',
                        })}
                    </span>
                </ModalKv>
                <ModalKv>
                    <span className="k">Trigger</span>
                    <span className="v">{triggerLabel(trigger)}</span>
                </ModalKv>
                <ModalKv>
                    <span className="k">Triggered by</span>
                    <span className="v">{triggeredByName || '—'}</span>
                </ModalKv>
                <ModalKv>
                    <span className="k">Reason</span>
                    <span className="v">{run.ReasonText || '—'}</span>
                </ModalKv>
                <ModalKv>
                    <span className="k">Window</span>
                    <span className="v">{formatRunWindow(run, timezone)}</span>
                </ModalKv>
                <ModalKv>
                    <span className="k">Reports included</span>
                    <span className="v">{run.ReportsIncluded ?? '—'}</span>
                </ModalKv>
                <ModalKv>
                    <span className="k">Recipients</span>
                    <span className="v">
                        {run.RecipientLabel ||
                            run.RecipientCount ||
                            (trigger === 'Test'
                                ? run.TestRecipientEmail || run.RecipientEmail
                                : '—')}
                    </span>
                </ModalKv>
                <ModalKv>
                    <span className="k">Render mode</span>
                    <span className="v">{run.RenderMode || '—'}</span>
                </ModalKv>
                <ModalKv>
                    <span className="k">CSV attached</span>
                    <span className="v">{run.CsvAttached ? 'Yes' : 'No'}</span>
                </ModalKv>
                <ModalKv>
                    <span className="k">Status</span>
                    <span className="v">
                        <StatusBadge $color={statusBadge.color}>
                            {statusBadge.label}
                        </StatusBadge>
                    </span>
                </ModalKv>
                <ModalKv>
                    <span className="k">Completed at</span>
                    <span className="v">
                        {run.CompletedAtUtc
                            ? `${formatUtcInTimezone(run.CompletedAtUtc, timezone)}${run.DurationSeconds != null ? ` (${run.DurationSeconds} sec)` : ''}`
                            : '—'}
                    </span>
                </ModalKv>
                {run.BounceCount != null && (
                    <ModalKv>
                        <span className="k">Bounces</span>
                        <span className="v">{run.BounceCount}</span>
                    </ModalKv>
                )}
                {(isFailed || run.ErrorMessage) && (
                    <ModalKv style={{ flexDirection: 'column', alignItems: 'stretch' }}>
                        <span className="k">Error</span>
                        <span className="v">
                            {run.ErrorMessage ? (
                                <ErrorPre>{run.ErrorMessage}</ErrorPre>
                            ) : (
                                '—'
                            )}
                        </span>
                    </ModalKv>
                )}
            </Modal.Content>
            <Modal.Actions>
                <AppButton onClick={onClose}>Close</AppButton>
            </Modal.Actions>
        </Modal>
    )
}
